module.exports = __webpack_public_path__ + "static/media/22.cab61a87.png";